import React from "react";

const Item = ({ title, body, index }) => (
  <div
    data-testid={`footer-item-${index}`}
    className="rounded-2xl bg-[#0f0f12] border border-white/5 p-5 text-left"
  >
    <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-violet-400 mb-2">
      {title}
    </div>
    <p className="text-sm text-zinc-400 leading-relaxed whitespace-pre-line">{body}</p>
  </div>
);

export const Footer = ({ settings }) => {
  return (
    <footer data-testid="site-footer" className="mt-12 border-t border-white/5">
      <div className="max-w-6xl mx-auto px-4 py-10">
        <h3 className="font-heading text-xl font-bold mb-6 text-white">
          Panduan · <span className="text-violet-400">Guide</span>
        </h3>
        <div className="grid gap-4 sm:grid-cols-3">
          <Item title="Cara Cancel Order" body={settings?.footer_cancel || "-"} index="cancel" />
          <Item title="Cara Refill" body={settings?.footer_refill || "-"} index="refill" />
          <Item title="Cara Check Order" body={settings?.footer_check_order || "-"} index="check" />
        </div>
        <div className="mt-8 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-zinc-500">
          <span>© {new Date().getFullYear()} AZMIEY STORE · SMM Panel Malaysia</span>
          <span className="font-mono">Powered by Azmiey · Made with care</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
